import * as React from "react";
import { ClipboardList, Loader2, FileX } from "lucide-react";
import DocumentCard from "../../molecules/DocumentCard";
import FieldsList from "../FieldsList/FieldsList";
import EmptyState from "../../molecules/EmptyState";
import { SchemaExtractionData, ExtractedDataField } from "../../../../../types/dataTypes";

interface DataGridProps {
  schemas: SchemaExtractionData[];
  onViewField?: (field: ExtractedDataField) => void;
  onMapToWord?: (field: ExtractedDataField) => void;
  onValidateField?: (schemaId: string, fieldId: string, isValid: boolean | null) => void;
  onFieldUpdate?: (fieldId: string, newValue: string) => void;
  className?: string;
}

const DataGrid: React.FC<DataGridProps> = ({ 
  schemas, 
  onViewField, 
  onMapToWord,
  onValidateField,
  onFieldUpdate,
  className = ''
}) => {
  if (!schemas || schemas.length === 0) {
    return (
      <EmptyState
        icon={ClipboardList}
        title="No extraction schemas"
        description="Extraction schemas will appear here once they have been configured for this workpill."
        className=""
      />
    );
  }

  return (
    <div className={className}>
      {schemas.map((schemaData) => (
        <DocumentCard
          key={schemaData.id}
          schemaData={schemaData}
          className="bg-white border border-slate-200 rounded-lg shadow-sm p-4 md:p-5"
        >
          {/* Fields Section */}
          {schemaData.extractedFields.length > 0 && (
            <FieldsList
              fields={schemaData.extractedFields}
              schemaId={schemaData.id}
              onViewField={onViewField}
              onMapToWord={onMapToWord}
              onValidateField={(fieldId, isValid) => 
                onValidateField && onValidateField(schemaData.id, fieldId, isValid)
              }
              onFieldUpdate={onFieldUpdate}
              className=""
            />
          )}

          {/* Processing state */}
          {schemaData.status === 'processing' && (
            <EmptyState
              icon={Loader2}
              title="Processing extraction..."
              description="Data extraction is in progress. This may take a few minutes."
              className=""
            />
          )}

          {/* Empty state for schemas without extractions */}
          {schemaData.status === 'empty' && (
            <EmptyState
              icon={FileX}
              title="No extracted data"
              description="No extracted data found for this schema in the current execution."
              className=""
            />
          )}
        </DocumentCard>
      ))}
    </div>
  );
};

export default DataGrid;
